
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gain",
      function () {
        return require("private-next-pages/gain/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gain"])
      });
    }
  